<!--
 * @Description: 
 * @Author: xiaoq
 * @Date: 2024-06-13 16:04:03
 * @LastEditTime: 2024-12-10 10:48:36
 * @LastEditors: xiaoq
-->
<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
        <div class="clickBox1" @click="gotoLink1"></div>
        <div class="clickBox2" @click="gotoLink2"></div>
        <div class="clickBox3" @click="gotoLink3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/pcainfoyserinte/components/img/footer.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      altText: "图片",
    };
  },
  methods: {
    gotoLink1() {
      window.open("https://www.gob.mx/cnbv", "_blank");
    },
    gotoLink2() {
      window.open("https://www.buro.gob.mx/", "_blank");
    },
    gotoLink3() {
      window.open("https://www.condusef.gob.mx/", "_blank");
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box {
  width: 100%;
  overflow: hidden;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6 {
  width: 100%;
  margin: auto;
}
.img1Box {
  position: relative;
}
.clickBox1 {
  position: absolute;
  background: transparent;
  width: 75px;
  height: 34px;
  top: 15%;
  left: 57%;
  cursor: pointer;
  /* border: 1px solid red; */
}
.clickBox2 {
  position: absolute;
  background: transparent;
  width: 280px;
  height: 34px;
  top: 39%;
  left: 57%;
  cursor: pointer;
  /* border: 1px solid red; */
}
.clickBox3 {
  position: absolute;
  background: transparent;
  width: 125px;
  height: 34px;
  top: 65.5%;
  left: 57%;
  cursor: pointer;
  /* border: 1px solid red; */
}
</style>
